import {daUtils} from '../_utils';
import {IApiResponse, IItemIdRequest, IItemSIdRequest, ICustomer, IMuiDataRequest, ICustomerDomainExists, ICustomerGetByEmail} from "./types";
import {API_PAF_BASE_URI} from "./index";

// import config from 'config';

const API_CUSTOMER_GET=`${API_PAF_BASE_URI}/companies/filter/`;
const API_CUSTOMER_GET_BY_ID=`${API_PAF_BASE_URI}/companies/{company_id}/`;
const API_CUSTOMER_GET_BY_SID=`${API_PAF_BASE_URI}/companies/sid/{company_sid}`;
const API_CUSTOMER_ADD=`${API_PAF_BASE_URI}/companies/`;
const API_CUSTOMER_UPD=`${API_PAF_BASE_URI}/companies/{company_id}/`;
const API_CUSTOMER_DEL=`${API_PAF_BASE_URI}/companies/{company_id}/`;
const API_CUSTOMER_DOMAIN_EXISTS_BY_EMAIL =`${API_PAF_BASE_URI}/companies/domain_exists/{email}/`;
const API_CUSTOMER_GET_BY_EMAIL =`${API_PAF_BASE_URI}/companies/user_email/{email}/`;
const API_CUSTOMER_DETAILS = `${API_PAF_BASE_URI}/companies/user/`;
const API_BROKER_ADD_GET_DETAILS = `${API_PAF_BASE_URI}/companies/company_add_user/{company_id}/`;


const get = async (
    options: IMuiDataRequest,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(options)
        };
        const url = API_CUSTOMER_GET;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const get_by_id = async (
    options: IItemIdRequest,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: 'GET',
            cache: "no-cache",
        };
        const id = options.id.toString();
        const url = API_CUSTOMER_GET_BY_ID.replace('{company_id}', id);
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const get_by_sid = async (
    options: IItemSIdRequest,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: 'GET',
            cache: "no-cache",
        };
        const sid = options.sid;
        const url = API_CUSTOMER_GET_BY_SID.replace('{company_sid}', sid);
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const add = async (
    options: ICustomer,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(options)
        };
        const url = API_CUSTOMER_ADD;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const update = async (
    options: ICustomer & { company_id?: number },
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions = {
            method: 'PUT',
            body: JSON.stringify(options)
        };
        // Use company_id from payload (API expects company_id, not customer_id)
        const id = (options.company_id || options.customer_id)!.toString();
        const url = API_CUSTOMER_UPD.replace('{company_id}', id);
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const remove = async (
    options: ICustomer & { company_id?: number },
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions = {
            method: 'DELETE',
            body: JSON.stringify(options)
        };
        const id = (options.company_id || options.customer_id)!.toString();
        const url = API_CUSTOMER_DEL.replace('{company_id}', id);
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const customers_domain_exists_by_email = async (
    options: ICustomerDomainExists,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: 'GET',
            cache: "no-cache",
        };
        const email = options.email;
        const url = API_CUSTOMER_DOMAIN_EXISTS_BY_EMAIL.replace('{email}', email);
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const customers_get_by_email = async (
    options: ICustomerGetByEmail,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: 'GET',
            cache: "no-cache",
        };
        const email = options.email;
        const url = API_CUSTOMER_GET_BY_EMAIL.replace('{email}', email);
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const get_customer_company_details = async (
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: 'GET',
            cache: "no-cache",
        };
        const url = API_CUSTOMER_DETAILS;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const get_broker_add_get_details = async (
    options: IItemIdRequest,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: 'GET',
            cache: "no-cache",
        };
        const id = options.id.toString();
        const url = API_BROKER_ADD_GET_DETAILS.replace('{company_id}', id);
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

export const customerApi = {
    get,
    get_by_id,
    add,
    update,
    remove,
    customers_domain_exists_by_email,
    customers_get_by_email,
    get_customer_company_details,
    get_broker_add_get_details,
};